import React, { useEffect, useState } from "react";
import { Loader, ShieldOff } from "lucide-react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

export default function ValidateToken() {
  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get("token");
  const navigate = useNavigate();

  const [authenticating, setAuthenticating] = useState(true);
  const [authorized, setAuthorized] = useState(true);

  useEffect(() => {
    validateNowcertsToken(token);
  }, []);

  const validateNowcertsToken = (token: any) => {
    setAuthenticating(true);
    var config = {
      method: "get",
      // url: `${process.env.REACT_APP_MAPSAPI}/api/account/validateNowcertsToken?token=${token}`,
      url: `${process.env.REACT_APP_MAPSAPI}/api/account/validatessotoken?token=${token}`,
    };

    axios(config)
      .then((response: any) => {
        if (response.data.token == "") {
        } else {
          localStorage.setItem("igtoken", response.data.token);
          localStorage.setItem("userName", response.data.userName);
          localStorage.setItem("NowcertsAgentId", response.data.nowCertsAgentId);
          localStorage.setItem("AvatarName", response.data.avatarName);
          navigate("/agencyinfo");
        }
      })
      .catch((error: any) => {
        setAuthenticating(false);
        setAuthorized(false);
      });
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white p-6 rounded shadow text-center w-full max-w-md ai-login-box">
        {/* SVG Logo */}
        <div className="flex justify-center mb-6">
          <svg className="h-full w-auto max-w-[180px]" viewBox="0 0 450 80" xmlns="http://www.w3.org/2000/svg">
            <g>
              <path d="M20 50 L40 40 L45 45 L45 70 L40 75 L20 65 Z" fill="#5BD584" />
              <path d="M55 35 L75 25 L80 30 L80 70 L75 75 L55 65 Z" fill="#5BD584" />
              <path d="M90 20 L110 10 L115 15 L115 70 L110 75 L90 65 Z" fill="#5BD584" />
            </g>
            <text x="135" y="45" fontFamily="Arial, sans-serif" fontSize="42" fontWeight="500" fill="#000000">
              momentum
            </text>
            <text x="135" y="70" fontFamily="Arial, sans-serif" fontSize="32" fontWeight="400" fill="#5BD584">
              maps
            </text>
          </svg>
        </div>

        {/* Authenticating or Denied State */}
        {authenticating ? (
          <>
            <h3 className="text-xl font-medium mb-4 text-gray-800">Authenticating User...</h3>
            <div className="flex justify-center mt-4">
              <Loader className="h-8 w-8 text-green-500 animate-spin" />
            </div>
          </>
        ) : authorized ? (
          <p className="text-green-600">Welcome! You are successfully logged in.</p>
        ) : (
          <>
            <ShieldOff className="h-10 w-10 text-red-500 mx-auto mb-4" />
            <p className="font-semibold text-lg text-red-600">You are not authorized</p>
            <p className="text-gray-600 mt-2">
              It seems like you don’t have permission to use this portal.
              <br />
              Please sign in with a different account.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
